/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetTaskListParams,
  TaskDataResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Task list API
 */
export const getTaskList = (params?: GetTaskListParams, signal?: AbortSignal) => {
  return customInstance<TaskDataResponseResponse>({
    url: `/bm-declaration-service/v1/task/list`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTaskListQueryKey = (params?: GetTaskListParams) => {
  return [`/bm-declaration-service/v1/task/list`, ...(params ? [params] : [])] as const;
};

export const getGetTaskListQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskList>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetTaskListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskList>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskList>>> = ({ signal }) =>
    getTaskList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTaskListQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskList>>>;
export type GetTaskListQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get Task list API
 */
export const useGetTaskList = <
  TData = Awaited<ReturnType<typeof getTaskList>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetTaskListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskList>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTaskListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
